(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["safety-concept-quantity"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bc-bundle-stepper')) {
  customElements.define('bc-bundle-stepper', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.bc-product');
      if (!this.root) return;
      this.abort = new AbortController();
      this.addEventListener('click', event => {
        const button = event.target.closest('button[data-direction]');
        if (!button) return;
        const offers = this.offers();
        const index = offers.findIndex(input => input.checked);
        const next = index + Number(button.dataset.direction);
        if (index >= 0 && next >= 0 && next < offers.length) {
          offers[next].click();
          this.sync();
        }
      }, {signal: this.abort.signal});
      this.root.addEventListener('change', () => this.sync(), {signal: this.abort.signal});
      this.observer = new MutationObserver(() => this.sync());
      this.observer.observe(this.root, {childList: true, subtree: true});
      this.sync();
    }
    offers() {
      return [...this.root.querySelectorAll('quantity-breaks input[type="radio"][name="quantity"]')].filter(input => !input.disabled);
    }
    sync() {
      const offers = this.offers();
      const index = offers.findIndex(input => input.checked);
      this.hidden = index < 0;
      if (index < 0) return;
      const output = this.querySelector('output');
      if (output.textContent !== offers[index].value) output.textContent = offers[index].value;
      this.querySelector('[data-direction="-1"]').disabled = index === 0;
      this.querySelector('[data-direction="1"]').disabled = index === offers.length - 1;
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
